export const contentType = {
  TWS_RICH_TEXT: 'twsRichText',
  TWS_EXPANDABLE_CONTAINER: 'twsExpandableContainer'
}
